import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserInfoChange } from "../../../redux/slices/user";
import { useEffect, useState } from "react";
import { AddressSuggestions } from "react-dadata";
import "react-dadata/dist/react-dadata.css";
import "./CompletionRegistration.scss";

const CompletionRegistration = ({
  openModal,
  handleOpenModal,
  handleCloseModal,
}) => {
  const { user } = useSelector(state => state.user);
  const dispatch = useDispatch();
  const tokenAPI = "3d63f990833cd7209df7786bd37d68a30d8f9df9";
  const [addressValue, setAddressValue] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    dispatch(fetchUserInfoChange());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      address: ["", "", ""],
    },
  });

  useEffect(() => {
    if (user && user.items && user.items.name) {
      setValue("name", user.items.name);
    }
  }, [user]);

  const handleDone = () => {
    openModal(false);
  };

  const handleAddressChange = suggestion => {
    if (suggestion && suggestion.value) {
      setAddressValue(suggestion.value);
      setValue("address[0]", suggestion.data.region || "");
      setValue("address[1]", suggestion.value);
      setValue("address[2]", suggestion.data.flat || "");
    }
  };

  const onSubmit = async values => {
    const data = await dispatch(fetchUserInfoChange(values));
    console.log(data);
    handleCloseModal();
    return data;
  };

  return (
    <>
      <div className="completion-registration__wrapper"></div>
      <div className="completion-registration">
        <div className="completion-registration__title">
          Завершите регистрацию
        </div>
        <form
          className="completion-registration__form"
          onSubmit={handleSubmit(onSubmit)}>
          <label>
            <div className="completion-registration__form-text">
              Как к Вам обращаться?
            </div>
            <input
              type="text"
              placeholder={`Имя${
                errors.name ? ` (${errors.name.message})` : ""
              }`}
              {...register("name", { required: "Введите имя!" })}
            />
          </label>
          <label>
            <div className="completion-registration__form-text">
              Адрес оказания услуги (по умолчанию)
            </div>
            <div className="completion-registration__form-inputs">
              <div className="address-suggestions-wrapper">
                {!isFocused && !addressValue && (
                  <div className="custom-placeholder">
                    Введите улицу и номер дома
                  </div>
                )}
                <AddressSuggestions
                  className={`completion-registration__form-input custom-address-input`}
                  token={tokenAPI}
                  value={addressValue}
                  onChange={handleAddressChange}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  filterLocations={[
                    { kladr_id: "77" }, // Москва
                    { kladr_id: "50" }, // Московская область
                    { kladr_id: "78" }, // Санкт-Петербург
                  ]}
                />
              </div>
              <input
                type="text"
                placeholder={`Наличие домофона${
                  errors.address && errors.address[2]
                    ? ` (${errors.address[2].message})`
                    : ""
                }`}
                {...register("address[2]", { required: "Укажите домофон" })}
              />
            </div>
          </label>
          <button
            type="submit"
            onClick={handleDone}
            className="completion-registration__form-button">
            Сохранить
          </button>
          <a
            href="/"
            onClick={handleCloseModal}
            className="completion-registration__form-button">
            закрыть
          </a>
        </form>
      </div>
    </>
  );
};

export default CompletionRegistration;
